import Court from './Court';

export default Court;
